import Marquee from "react-fast-marquee";

const items = [
  "MEME OUR WAY TO A HOMELESS-FREE FUTURE",
  "#ENDHOMELESSNESS",
  "CRYPTO FOR GOOD",
  "#HRSREFORM",
  "BUY · HOLD · SHARE",
];

export const EditorialMarquee = () => {
  return (
    <section className="relative py-6 border-y border-white/10 bg-[#ff007f] overflow-hidden" data-testid="marquee-section">
      <Marquee speed={45} gradient={false} autoFill>
        {items.map((t, i) => (
          <span
            key={i}
            className="font-street uppercase text-xl sm:text-3xl text-black tracking-tight mx-8 flex items-center gap-8"
          >
            {t}
            <span className="text-black/40">✳</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
